<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">

      
      
    </base-header>

    <!--start container-->
    

    <div class="container-fluid mt--6">

    
     <div class="row">
    

     <div class="col-xl-6">
     
     <card style="padding-bottom:50px;">
      <div class="invoice-box" style="min-height:700px;">
        <table cellpadding="0" cellspacing="0">
            <tr class="top">
                <td colspan="2">
                    <table>
                        <tr>
                            <td class="title">
                            	  <img src='/img/easily_logo-3-b.png' style="width:120px;" />
                            </td>
                            
                            <td>
                                <strong>INVOICE #{{invoice.id}}</strong><br>
                                <span>Date: {{invoice.created_at_str}}</span><br>
                               <span v-if="0"> Due: February 1, 2015</span>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            
            <tr class="information">
                <td colspan="2">
                    <table>
                        <tr>
                            <td>
                            	<span style="font-weight:bold;">LBSS</span><br/>
                                400 Orchard Road<br>
                                 #05-25<br>
                                Singapore 238875
                            </td>
                            
                            <td>
                               <div style="max-width:220px;float:right"> 
                               	<strong>Invoice To</strong><br/>
                                <span v-if="invoice.entity && is_incorp==0">
                                {{invoice.entity.entity_name}}<br>
                                {{invoice.entity.registered_address}}
                                </span>
                                <span v-else-if="is_incorp==1">
                                	{{incorp.person.first_name}} {{incorp.person.last_name}}
                                </span>
                                 <span v-else-if="is_incorp==2">
                                	{{incorp.entity_name}} 
                                </span>
                                
                                </div>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            
            <tr class="heading">
                <td>
                    Payment Method
                </td>
                
                <td>
                    Status
                </td>
            </tr>
            
            <tr class="details">
                <td>
                    Credit/Debit Card
                </td>
                
                <td>
                     <base-button type="danger" v-if="invoice.status==1">Not Paid</base-button>
                     <base-button type="success" v-if="invoice.status==2">Paid</base-button>
                </td>
            </tr>
            
            <tr class="heading">
                <td>
                    Item
                </td>
                
                <td>
                    Price
                </td>
            </tr>
            
            <tr class="item">
                <td>
                    {{invoice.title}}
                    <div v-if="invoice.description" style="font-size:12px;color:#999;">  {{invoice.description}}</div>
                    
                </td>
                
                <td>
                    $ {{invoice.amount_str}}
                </td>
            </tr>
            
            
             <tr  v-for="ii in invoice_items" class="item"  :key="ii.id">
                <td>
                    {{ii.title}}
                    <div v-if="ii.description" style="font-size:12px;color:#999;">  {{ii.description}}</div>
                    
                </td>
                
                <td>
                    $ {{ii.amount_str}}
                </td>
            </tr>
            
            
            
           
            
            
           
            
            <tr class="total">
                <td></td>
                
                <td>
                   Total<br/>${{invoice_total_amount_str}}
                </td>
            </tr>
        </table>
    </div>



	</card>
	</div><!-- end left column-->
	<div  v-if="is_incorp==1 && invoice.status==2">
	<card style="margin-top:30px;">
	
		  <base-button block type="default" @click.prevent="go_incorp_form">Continue With Incorporating Your New Company</base-button>
	</card>
	</div>
	
	<div  v-if="is_incorp==2 && invoice.status==2">
	<card style="margin-top:30px;">
	
		  <base-button block type="default" @click.prevent="go_appoint_form">Continue With Appointing Us As Your New Secretary</base-button>
	</card>
	</div>
	
	 <div v-if="invoice.status==1 && showStripe==0" class="col-xl-6">
	 <card style="margin-top:30px;">
	      <base-button block type="warning" @click.prevent="start_stripe" style="padding-top:20px;padding-bottom:20px;font-size:18px;">Pay Now Via Credit/Debit Card</base-button>
	   
	   </card>
	   
	     <card style="">
		 	 <div class="text-center"><span class="h6 surtitle"> For other payment methods, please email us.</span></div>
	 	 </card>
	  
	 
	 </div>
	
	 <div v-if="invoice.status==1"  class="col-xl-6" ref="stripe_cc" style="display:none;">
	  <card header-classes="bg-gradient-default">
	  	 <div slot="header" class="row align-items-center">
	  	 	<div class="col text-center">
	  	    <h3 class="h3 text-white">	Make Payment Via Credit/Debit Card </h3>
	  	    </div>
	  	 </div>
	  <div class="row">
	 	 <div class="col-md-6">
                    <base-input v-model="payer.first_name" prepend-icon="fas fa-user" placeholder="First name"></base-input>
                  </div>
         <div class="col-md-6">
                    <base-input  v-model="payer.last_name" placeholder="Last name"></base-input>
            </div>
   	 </div>
	  
	   <div ref="card"></div>
	   		
	   	   <div style="margin-top:30px;">
	      <base-button block type="primary" @click.prevent="new_purchase">Click To Pay</base-button>
	      </div>
	   </card>
	   
	 </div><!-- end right column-->
	  
	
    </div>
    
      
	
	   
	    
	    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  		
    },
    data() {
      return {
     	 invoice:[],
     	 invoice_items:[],
     	 invoice_total_amount_str: "",
     	 stripe:[],
     	 card:[],
     	 stripe_cs:[],
     	 is_incorp: 0,
     	 incorp: {
     	 	person:[]
     	 },
     	 payer:[],
     	 payment_model:{
     	 	 stripe_token:[],
     	 	 iid: this.$route.params.iid,
     	 },
     	 showStripe: 0,
     	 invoice_result:{
     	 	stripe_id:'',
     	 	iid:this.$route.params.iid,
     	 },
      };
    },
    methods: {
    	go_incorp_form(){
    		this.$router.push( '/incorporation')
    	
    	},
    	go_appoint_form(){
    		this.$router.push( '/onboarding-appoint-form-details')
    	
    	},
    	new_purchase(){
    		//ev.preventDefault();
    			 swal.showLoading();
    		   const vm = this;
			  this.stripe.confirmCardPayment(this.stripe_cs, {
				payment_method: {
				  card: this.card,
				  billing_details: {
					name: this.payer.first_name+' '+this.payer.last_name
				  }
				}
			  }).then(function(result) {
				if (result.error) {
				  // Show error to your customer (e.g., insufficient funds)
				  	swal.fire({
							title: `Oops`,
							text: result.error.message,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
					})
				  console.log(result.error.message);
				} else {
				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
					
						vm.update_invoice_success(result.paymentIntent.id);
				  }
				  
				}
			  });
    	
    	
    	
    	},
    	update_invoice_success(intent_id){
    		this.invoice_result.stripe_id = intent_id;
    		const vm = this;
    		let uri = this.$base_url+'/api/v1/c/update_invoice_success';
         	ApiService.post(uri, this.invoice_result).then(response => {
         			//  swal.close();
         			
         			swal.fire({
						title: `Payment Successful!`,
						text: 'Your invoice has been paid.',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-success',
						icon: 'success'
					  }).then(function(){
							vm.load_invoice();
						})
         			
         			  
         	
					
					
   
     	 	});
    	
    	
    	
    	},
    	start_stripe(){
    		 swal.showLoading();
    		this.$refs.stripe_cc.style.display = "block"; 
    		this.showStripe = 1;
    		let uri = this.$base_url+'/api/v1/c/setup_stripe/'+ this.$route.params.iid;
       		  ApiService.get(uri).then(response => {
         	
				
      			 this.stripe_cs = response.data.intent.client_secret
   				 this.setup_stripe();
   				 
      		})
    	
    	
    	},
    	setup_stripe(){
    	
    	
    		//start: stripe setup
    		let stripe_key = process.env.VUE_APP_STRIPE_KEY;
    		
    		
			let stripe = Stripe(stripe_key),
			elements = stripe.elements(),
			card = undefined;
		
			var style = {
			  base: {

				color: "#000",
					fontSize: '13px',
			  },

			  invalid: {
				// All of the error styles go inside of here.
			  }

			};
	
	
			card = elements.create('card', {style: style});
			 card.mount(this.$refs.card);
			this.stripe = stripe;
			this.card = card;
			//end stripe setup
    		swal.close();
    	
    	
    	},
    	
    	load_invoice(){
    		 swal.showLoading();
      		const vm = this;
			const client_info = JSON.parse(TokenService.getUserInfo());
			let uri = this.$base_url+'/api/v1/c/get_invoice/'+ this.$route.params.iid;
			 ApiService.get(uri).then(response => {
				if(response.data.incorp){
					this.is_incorp = response.data.incorp.is_incorp;
					this.incorp = response.data.incorp;
				}

				 vm.invoice = response.data.invoice;
				 vm.invoice_items = response.data.invoice.invoice_items;
				 vm.invoice_total_amount_str = response.data.invoice_total_amount_str;
				 
				 
				 swal.close();
			})
    	}
    	
 	/*	purchase () {
 			  let self = this;
 			  this.stripe.createToken(self.card).then(function(result) {
 			 	  console.log(result)
 			 
    			  if (result.error) {
    			   	alert("error:"+result.error.message);


					  self.hasCardErrors = true;
					  self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
					  return;
				  }
				  else{
				  		self.payment_model.stripe_token = result.token;
				  		self.processPayment();
				  		
				  }
   			 });
    	}, 	
       processPayment(){
       		let uri = this.$base_url+'/api/v1/c/process_payment/'+ this.$route.params.iid;
          	ApiService.post(uri, this.payment_model).then(response => {
         	

   
      		})
       
       }*/
    },
    mounted() {
    	 
      		this.load_invoice();
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}


   /* Blue outline on focus */
        .StripeElement {

            border:1px solid #000;
            padding-top:15px;
            padding-bottom:15px;
            padding-left:10px;
            padding-right:5px;
            

        }
        
        

.invoice-box {
        max-width: 800px;
        margin: auto;
        padding: 30px;
        border: 1px solid #eee;
        box-shadow: 0 0 10px rgba(0, 0, 0, .15);
        font-size: 16px;
        line-height: 24px;
        font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
        color: #555;
    }
    
    .invoice-box table {
        width: 100%;
        line-height: inherit;
        text-align: left;
    }
    
    .invoice-box table td {
        padding: 5px;
        vertical-align: top;
    }
    
    .invoice-box table tr td:nth-child(2) {
        text-align: right;
    }
    
    .invoice-box table tr.top table td {
        padding-bottom: 20px;
    }
    
    .invoice-box table tr.top table td.title {
        font-size: 45px;
        line-height: 45px;
        color: #333;
    }
    
    .invoice-box table tr.information table td {
        padding-bottom: 40px;
    }
    
    .invoice-box table tr.heading td {
        background: #eee;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
    }
    
    .invoice-box table tr.details td {
        padding-bottom: 20px;
    }
    
    .invoice-box table tr.item td{
        border-bottom: 1px solid #eee;
    }
    
    .invoice-box table tr.item.last td {
        border-bottom: none;
    }
    
    .invoice-box table tr.total td:nth-child(2) {
        border-top: 2px solid #eee;
        font-weight: bold;
    }
    
    @media only screen and (max-width: 600px) {
        .invoice-box table tr.top table td {
            width: 100%;
            display: block;
            text-align: center;
        }
        
        .invoice-box table tr.information table td {
            width: 100%;
            display: block;
            text-align: center;
        }
    }

</style>











